import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import { ContactInfo } from '@/features/tax-profile/ContactInfo'
import { BusinessInfo } from '@/features/tax-profile/business-profiles/BusinessInfo'

export type BusinessProfileVersionProps = ModelProps<BusinessProfileVersion>

/**
 * BusinessProfileVersion
 */
export class BusinessProfileVersion extends Model<BusinessProfileVersion> {
  id = Id.none

  @observable accessor version = 0
  @observable accessor workspaceId = Id.none
  @observable accessor ownerUserId = Id.none
  @observable accessor createdAt = unixEpoch()
  @observable accessor updatedAt = unixEpoch()
  @observable.shallow accessor businessInfo: BusinessInfo = BusinessInfo.empty
  @observable.shallow accessor contactInfo: ContactInfo = ContactInfo.empty

  /**
   * Whether the profile version has the given identity.
   */
  equalsIdentity(id: Id, version: number | undefined) {
    return this.id === id && this.version === version
  }
}

/**
 * Utility for formatting an ID string for use with the backing collection of
 * business profile versions.
 */
export const BusinessProfileVersionId = {
  /**
   * Creates a version ID string from the profile ID and version.
   */
  from: (id: Id, version: number | undefined): string => {
    if (version === undefined) {
      throw new TypeError('Profile version ID cannot be undefined')
    }

    return `${Id.assert(id)}@v${version}`
  },
}
